import Metadata from './metadata';

export default function getCountries(metadata) {
	return new Metadata(metadata).getCountries();
}
//# sourceMappingURL=getCountries.js.map


//////////////////
// WEBPACK FOOTER
// ./~/libphonenumber-js/es6/getCountries.js
// module id = 3lhq
// module chunks = 0